import { Alert, AlertProps, Button, Snackbar, Typography } from '@mui/material';
import { FC } from 'react';
import { alertButtonStyle } from '../styled';

export interface IResponseAlertProps extends AlertProps {
  onClose: () => void,
  open: boolean,
}

export const ResponseAlert: FC<IResponseAlertProps> = ({
  severity = 'error',
  onClose,
  open
}) => (
  <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open}>
    <Alert
      severity={severity}
      title="The declaration window has expired for this Shift!"
      variant="filled"
    >
      <Typography sx={{ fontWeight: 'bold', mb: 1 }}>The declaration window has expired for this Shift!</Typography>
      <Typography sx={{ mb: 1 }}>You won’t be able to submit your changes at this time.</Typography>
      <Typography sx={{ mb: 1 }}>The page will refresh when you click on the [OK] button below.</Typography>
      <Button
        variant='text'
        sx={alertButtonStyle}
        onClick={onClose}
      >
        OK
      </Button>
    </Alert>
  </Snackbar>
)